// Bootstrap file - ensures React is loaded before any other code
// This file MUST be imported first in index.tsx

// Force synchronous load of React and React-DOM
import React from 'react';
import ReactDOM from 'react-dom/client';

// Re-export for use by other modules
export { React, ReactDOM };

// Ensure React is initialized
if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
  throw new Error('React failed to load!');
}

// Only log in development
if (import.meta.env.DEV) {
  console.log('[Bootstrap] React and ReactDOM loaded successfully');
}
